export const AGENDA = 'agenda'
export const ORGANIZERS = 'organizers'
export const PARTICIPANTS = 'participants'
export const SPEAKERS = 'speakers'
export const USEFUL_CONTACTS = 'useful_contacts'
export const ACTIVITIES_PHOTOS = 'activities_photos'
export const ACTIVITIES_LONG_DESCRIPTION = 'activities_long_description'
export const TIPS = 'tips'
export const GALLERY = 'gallery'
export const LOGO = 'logo'
export const CONTACTS_DESCRIPTION = 'contacts_description'

export const PLANIFY_IMAGE_STRIPE_CHECKOUT =
  'https://is4-ssl.mzstatic.com/image/thumb/Purple118/v4/1e/5b/29/1e5b29e8-06ab-d970-6d86-b389645b94ee/AppIcon-1x_U007emarketing-85-220-0-9.png/1200x630wa.jpg'

export const isDev = process.env.NODE_ENV === 'development'
